<app-header *ngIf="showHeader"></app-header>

<app-settings *ngIf="settings else noSettingsTemp"></app-settings>

<ng-template #noSettingsTemp style="height: 100vh !important;">
  <router-outlet></router-outlet>
</ng-template>
